import { QuestionMarkCircleIcon } from '@heroicons/react/24/outline';

import { cn } from '@/renderer/utils/cn';

export function Empty({
  IconComponent = QuestionMarkCircleIcon,
  icon = null,
  title = '',
  description = '',
  className = '',
}: {
  IconComponent?:
    | React.ForwardRefExoticComponent<React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>>
    | ((props: React.ComponentPropsWithoutRef<'svg'>) => JSX.Element);
  icon?: React.ReactNode;
  title?: React.ReactNode;
  description?: React.ReactNode;
  className?: string;
}) {
  return (
    <aside
      className={cn(
        'flex h-full select-none flex-col items-center justify-center space-y-8 rounded-lg text-center',
        className,
      )}
    >
      <div className="mx-auto flex w-fit flex-col space-y-8 rounded-sm border-2 border-dashed border-zinc-500 p-12">
        {icon || (
          <IconComponent
            height={48}
            className="mx-auto size-12 stroke-current stroke-1 text-center text-zinc-500 dark:text-zinc-400"
          />
        )}
        {!!title && <h2 className="text-lg text-zinc-800 dark:text-white">{title}</h2>}
        {!!description && (
          <p className="max-w-md text-sm leading-6 text-zinc-500 dark:text-zinc-300">
            {description}
          </p>
        )}
      </div>
    </aside>
  );
}
